import { withStyles } from '@material-ui/core';
import SmallCard from './SmallCard';
import styles from './styles';

export default withStyles(styles)(SmallCard);
